require('./angular/app.js');
require('./angular/services/ReportTrackModal.js');



// WEBPACK FOOTER //
// ./src/SMFCoreClientBundle/Resources/js/index.js